import Identity from '../../repo/identity';
import template from './index.tpl';
import './index.css';
import observe from '../../util/observe';

export default DomClass(template, function Authenticator() {
	var _t = this;

	const SIGN_OUT = "Sign out";
	const SIGN_IN = "Sign in";
	const SIGNED_OUT = "Anonymous";

	this.user = Identity.user;

	this.setUser = function(user) {
		_t.user = user;
		if (_t.user) {
			_t.username = _t.user.attributes.email;
			_t.action = SIGN_OUT;
		} else {
			_t.username = SIGNED_OUT;
			_t.action = SIGN_IN;
		}
	};

	this.__dom.action.onclick = function() {
		if (_t.action == SIGN_IN) {
			Identity.signIn();
		} else {
			Identity.signOut();
		}
	};

	observe(Identity, 'user', user => this.setUser(user));
	
});